import { Fragment, useContext, useState } from "react";
import { NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Drawer, Grid, List, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";

//import general components
import LanguageSelector from "../language/language";
import ArrowIcon from "../arrow-icon/arrow-icon";

//import images and icons
import logoImage from "../../../assets/imgs/new-logo.png";
import logoImageEn from "../../../assets/imgs/new-logo-en.png";
import { Add, ArrowLeft2, ArrowRight2, HambergerMenu, ProfileCircle } from "iconsax-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function MobileHeader({ menuList, handleMenuClick }) {
    //general variables
    const location = useLocation();
    const navigate = useNavigate();
    const [_, setSearchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //go to home
    const goToHome = () => {
        sessionStorage.clear()
        navigate(`/${locale}/flight-search/domestic`);
    };

    //navigate to user panel
    const navigateToUserPanel = () => {
        if (accessToken) {
            navigate(`/${locale}/user-panel`);
        } else if (location.pathname !== `/${locale}/login`) {
            setSearchParams({ action: "login" });
        }
    };

    const [open, setOpen] = useState(false);
    const toggleDrawer = newOpen => () => {
        setOpen(newOpen);
    };

    const DrawerList = (
        <Grid sx={{ width: 250 }} role="presentation">
            <List>
                <Grid className="header__title" container item xs={12} columnGap={1}>
                    <Add color="var(--light-color)" onClick={toggleDrawer(false)} />
                    <span>{t("menu")}</span>
                </Grid>

                {menuList?.map((menuItem, index) => (
                    <Fragment key={menuItem.id}>
                        <Grid
                            className={`header__menu-item ${locale === "en" ? "ltr" : "rtl"}`}
                            component="li"
                            key={index}
                            container
                            item
                            xs={12}
                            md="auto"
                            justifyContent="flex-start"
                            alignItems="center"
                            ml={6}
                        >
                            {!!menuItem?.subMenu ? (
                                <Accordion sx={{ boxShadow: "none", width: "100%" }}>
                                    <AccordionSummary
                                        className="header__menu-link"
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                        sx={{
                                            minHeight: "fit-content !important",
                                            backgroundColor: "var(--white-gray-color)",
                                            "& .MuiAccordionSummary-content": { margin: "10px 0 !important", columnGap: "0.5rem" },
                                            "&:hover": {
                                                backgroundColor: "var(--white-gray-color)",
                                                borderRadius: "0",
                                            },
                                        }}
                                    >
                                        {menuItem.icon}
                                        {menuItem.label}
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: "0 16px" }}>
                                        {menuItem.subMenu.map(sub => {
                                            return (
                                                <NavLink
                                                    key={sub?.id}
                                                    className={`header__menu-link ${sub.to === location.pathname && "activeItem"}`}
                                                    to={sub?.to}
                                                    onClick={event => {
                                                        handleMenuClick(event, sub);
                                                        setOpen(false);
                                                    }}
                                                >
                                                    {sub.to === location.pathname && (
                                                        <ArrowIcon
                                                            icons={[ArrowLeft2, ArrowRight2]}
                                                            isExpanded={locale === "en"}
                                                            size="16"
                                                            color="var(--primary-color)"
                                                            variant="Bold"
                                                        />
                                                    )}
                                                    {sub.label}
                                                </NavLink>
                                            );
                                        })}
                                    </AccordionDetails>
                                </Accordion>
                            ) : (
                                <NavLink
                                    className="header__menu-link"
                                    to={menuItem.to}
                                    onClick={event => {
                                        handleMenuClick(event, menuItem);
                                        setOpen(false);
                                    }}
                                >
                                    {menuItem?.icon}
                                    {menuItem.label}
                                </NavLink>
                            )}
                        </Grid>
                        <Divider />
                    </Fragment>
                ))}
            </List>

            <LanguageSelector setOpen={setOpen} />
        </Grid>
    );

    return (
        <Grid container item xs={12} alignItems="center">
            <Grid container item xs={3}>
                <HambergerMenu color="var(--light-color)" onClick={toggleDrawer(true)} />
            </Grid>
            <Drawer
                open={open}
                onClose={toggleDrawer(false)}
                sx={{ zIndex: "1400", "& .MuiDrawer-paper": { backgroundColor: "var(--white-gray-color)" }, ul: { padding: 0 } }}
            >
                {DrawerList}
            </Drawer>
            <Grid container item xs={6} justifyContent="center">
                <img alt="go home" className="header__logo-image" src={locale === "fa" ? logoImage : logoImageEn} onClick={goToHome} />
            </Grid>

            <Grid container item xs={3} justifyContent="flex-end">
                <ProfileCircle color="var(--light-color)" onClick={navigateToUserPanel} />
            </Grid>
        </Grid>
    );
}

export default MobileHeader;
